import React from 'react';
import './Foto.css';

interface WidgetProps {
  onClose: () => void;
  className?: string;
}

const Foto: React.FC<WidgetProps> = ({ onClose, className }) => {
  return (
    <div className={`widget-card foto-widget ${className || ''}`}>
      <div className="widget-header">
        <h3>Foto</h3>
        <button onClick={onClose} className="widget-close-btn" aria-label="Chiudi widget Foto">
          <i className="fas fa-times"></i>
        </button>
      </div>
      <div className="widget-content">
        <p>Gestione e visualizzazione delle foto...</p>
      </div>
    </div>
  );
};

export default Foto; 